export default __webpack_public_path__ + "images/80581e36441103720150813ca7aa7a02.png";